import { createFileRoute } from '@tanstack/react-router';

import { MyLabHome } from '../../features/mylab/mylab-home';

/**
 * `/mylab` — S4 오늘, 로그인 게이트의 도착지 (E14 §2)
 *
 * 라우트는 얇게 둔다: 화면은 `features/mylab`에 있다. 게이트는 부모 `mylab.tsx`가 맡는다.
 * 이 화면의 중심은 마지막 활동 이어하기다 — Lab log 작성·조회는 `/mylab/lab-log`(S20)로
 * 분리됐다(D99). 인접 상세 선택은 `detail` search param에 싣는다(E14 §3).
 */
interface MyLabHomeSearch {
  detail?: string;
}

export const Route = createFileRoute('/mylab/')({
  validateSearch: (search: Record<string, unknown>): MyLabHomeSearch => ({
    detail: typeof search.detail === 'string' ? search.detail : undefined,
  }),
  component: MyLabHomeRoute,
});

function MyLabHomeRoute() {
  const { detail } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MyLabHome
      detail={detail}
      // 닫기는 히스토리를 바꿔 쓴다 — 닫은 뒤 브라우저 뒤로 가기가 방금 닫은 상세를 다시 열지 않게
      setDetail={(value) => navigate({ search: { detail: value }, replace: value === undefined })}
    />
  );
}
